import { Document, DocumentFilter } from '@idea2app/ai-work-order-service';
import { Icon } from 'idea-react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Column, Field, RestTable } from 'mobx-restful-table';
import { Component } from 'react';
import { Button, Card, FormCheck } from 'react-bootstrap';
import { ByteSize } from 'web-utility';

import documentStore from '../model/Document';
import { i18n, t } from '../model/Translation';

@observer
export class DocumentListPage extends Component {
    @computed
    get filterFields(): Field<DocumentFilter>[] {
        return [
            { key: 'keywords', renderLabel: t('search') },
            { key: 'title', renderLabel: t('document_name') },
            { key: 'fileName', renderLabel: t('document_name') },
            { key: 'fileType', renderLabel: t('file_type') },
            { key: 'category', renderLabel: t('category') }
        ];
    }

    @computed
    get columns(): Column<Document>[] {
        return [
            {
                key: 'title',
                renderHead: t('document_name')
            },
            {
                key: 'fileType',
                renderHead: t('file_type')
            },
            {
                key: 'fileSize',
                type: 'number',
                renderHead: t('file_size'),
                renderBody: ({ fileSize }) =>
                    fileSize ? new ByteSize(fileSize).toShortString() : '-'
            },
            {
                key: 'updatedAt',
                renderHead: t('last_update_time'),
                renderBody: ({ updatedAt }) =>
                    new Date(updatedAt).toLocaleString()
            },
            {
                // key: 'status',
                renderHead: t('status'),
                renderBody: () => (
                    <div className="d-flex align-items-center gap-2">
                        启用
                        <FormCheck type="switch" />
                    </div>
                )
            }
        ];
    }

    render() {
        return (
            <Card className="m-3" body>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>{t('document_knowledge_base')}</h2>
                    <Button variant="primary" href="#/document/upload">
                        <Icon name="upload" className="me-2" />
                        {t('upload_document')}
                    </Button>
                </div>

                <RestTable
                    className="text-center"
                    filterFields={this.filterFields}
                    columns={this.columns}
                    store={documentStore}
                    translator={i18n}
                    striped
                    hover
                    deletable
                />
            </Card>
        );
    }
}
